import { Button, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import DataTableFilterLabel from 'Components/Generic/AdvancedDataTable/DataTableFilterLabel';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import styles from 'Styles/styles.module.css';

const BOSSelect = ({
  listData,
  onItemSelect = () => {},
  idField = 'id',
  labelField = 'name',
  labelFunction,
  placeholder = 'Select...',
  labelText,
  fill = false,
  defaultSelectedId,
  initialSelectedItem,
  inputClassName,
  outerClassName,
  floatSelected = true,
  isRequired = false,
  onBlur = () => {},
  isHeader = false,
}) => {
  const [selectedItem, setSelectedItem] = useState(initialSelectedItem || {});
  const [defaultSelectedItem, setDefaultSelectedItem] = useState({});

  useEffect(() => {
    if (defaultSelectedId && listData?.length) {
      setDefaultSelectedItem(
        listData.find((item) => item[idField] === defaultSelectedId),
      );
    } else {
      setDefaultSelectedItem(null);
    }
  }, [defaultSelectedId, listData]);

  useEffect(() => {
    if (defaultSelectedItem) {
      setSelectedItem(defaultSelectedItem);
    } else {
      setSelectedItem(null);
    }
  }, [defaultSelectedItem]);

  const itemRenderer = (item, { handleClick, handleFocus, modifiers }) => {
    return (
      <MenuItem
        key={item[idField] || -1}
        active={modifiers.active}
        icon={item === selectedItem ? 'tick' : 'blank'}
        shouldDismissPopover={false}
        text={labelFunction ? labelFunction(item) : item[labelField] || ''}
        onClick={handleClick}
        onFocus={handleFocus}
      />
    );
  };

  const onItemSelected = (item) => {
    setSelectedItem(item);
    onItemSelect(item);
  };

  let sortedArray =
    floatSelected && listData
      ? [
          ...listData.filter((item) => item === selectedItem),
          ...listData.filter((item) => item !== selectedItem),
        ]
      : listData;

  return (
    <div
      className={`${
        isHeader
          ? styles.filter_label_header_box
          : styles.filter_label_input_box
      } bp5-input-group ${
        !selectedItem && isRequired ? 'bp5-intent-danger' : ''
      } ${outerClassName ? outerClassName : ''}`}
      onClick={onBlur}>
      {labelText && <DataTableFilterLabel label={labelText} />}
      <Select
        key={(selectedItem && selectedItem[idField]) || 0}
        itemRenderer={itemRenderer}
        items={sortedArray}
        itemsEqual={idField}
        filterable={false}
        onItemSelect={onItemSelected}
        defaultSelectedItem={defaultSelectedItem}
        selectedItem={selectedItem}
        popoverProps={{ minimal: true }}
        popoverContentProps={{
          className: styles.filter_selection_menu,
        }}
        fill={fill}>
        <div
          className={`bp5-input${!selectedItem ? ' bp5-text-muted ' : ' '}${
            inputClassName ? inputClassName : ''
          }`}
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingRight: 0,
          }}>
          <label
            className={` ${
              !selectedItem
                ? isRequired
                  ? `bp5-intent-danger ${styles.required}`
                  : 'bp5-text-muted'
                : ''
            }`}
            style={{ flexGrow: 1, whiteSpace: 'nowrap', overflowX: 'hidden' }}>
            {selectedItem
              ? labelFunction
                ? labelFunction(selectedItem)
                : selectedItem[labelField] || ''
              : isRequired
              ? '(Required)'
              : placeholder}
          </label>
          <Button minimal icon={'chevron-down'} />
        </div>
      </Select>
    </div>
  );
};

BOSSelect.propTypes = {
  listData: PropTypes.array,
  onItemSelect: PropTypes.func,
  idField: PropTypes.string,
  labelField: PropTypes.string,
  labelText: PropTypes.string,
  labelFunction: PropTypes.func,
  searchField: PropTypes.string,
  placeholder: PropTypes.string,
  fill: PropTypes.bool,
  defaultSelectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  initialSelectedItem: PropTypes.object,
  inputClassName: PropTypes.string,
  outerClassName: PropTypes.string,
  floatSelected: PropTypes.bool,
  isRequired: PropTypes.bool,
  isHeader: PropTypes.bool,
  onBlur: PropTypes.func,
};

export default BOSSelect;
